import React from 'react';
import {OrderType} from "../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import PopupModal from "../../../../components/Modal/PopupModal";
import MultistoreOrderTypesModalElement from "./MultistoreOrderTypesModalElement";

interface Props {
    orderTypes: OrderType[];
    show: boolean;
    onHide: () => void;
    link: string;
}

const MultistoreOrderTypesModal = ({orderTypes, show, onHide, link}: Props) => {
    const {t} = useTranslation();

    return (
        <PopupModal
            title={t("modules.multistore.field.select_order_type.title")}
            className="multistore-order-types-modal"
            show={show}
            onHide={onHide}
            bodyContent={
                <div className="d-flex flex-column gap-2 pt-4 elements-container">
                    {orderTypes.map(orderType => (
                        <MultistoreOrderTypesModalElement link={link} orderType={orderType} key={orderType}/>
                    ))}
                </div>
            }
        />
    )
}

export default MultistoreOrderTypesModal;